import React from 'react'

const String = () => {
    return (
        <div className='container'>
            <h1>Python</h1>
            <h3>What is String in python?</h3>
            A string is a sequence of characters. <br /> <br />

A character is simply a symbol. For example, the English language has 26 characters.<br /><br />

Computers do not deal with characters, they deal with numbers (binary). Even though you may see characters on your screen, internally it is stored and manipulated as a combination of 0s and 1s.<br /><br />

This conversion of character to a number is called encoding, and the reverse process is decoding. ASCII and Unicode are some of the popular encodings used.<br /><br />

In Python, a string is a sequence of Unicode characters. Unicode was introduced to include every character in all languages and bring uniformity in encoding. You can learn about Unicode from Python Unicode.<br /><br />
        
        <h3>How to create a string in Python?</h3>
        <p>Strings can be created by enclosing characters inside a single quote or double-quotes. Even triple quotes can be used in Python but generally used to represent multiline strings and docstrings.</p>
       <div className='containers'>
        <code class="python hljs"><span class="comment"># defining strings in Python</span> <br />
<span class="comment"># all of the following are equivalent</span><br />
my_string = <span class="keywords">'Hello'</span><br />
&nbsp; <span class="library">print</span>(my_string)<br /><br />

my_string = <span class="keywords">"Hello"</span><br />
&nbsp;<span class="library">print</span>(my_string)<br /><br />

my_string = <span class="keywords">'''Hello'''</span><br />
&nbsp;<span class="library">print</span>(my_string)<br />
<br />
<span class="comment"># triple quotes string can extend multiple lines</span><br />
&nbsp;my_string = <span class="keywords">"""Hello, welcome to<br />
           the world of Python"""</span><br />
<span class="library">print</span>(my_string)<div title="Click to copy" class="copy-code-button"></div></code><br />
        </div>
        </div>
    )
}

export default String
